(() => {
  if (window.sparklesDecoReady) return;
  window.sparklesDecoReady = true;

  const SPEED = 0.6; // px of mask shift per px of scroll
  let lastScrollY = window.scrollY;
  let pending = false;
  let scrollDelta = 0;

  const getHosts = () => {
    const hosts = new Set();
    document.querySelectorAll('.sparkles-deco').forEach((el) => {
      const host = el.parentElement;
      if (host) hosts.add(host);
    });
    return hosts;
  };

  const update = () => {
    pending = false;
    getHosts().forEach((host) => {
      const current = parseFloat(host.dataset.sparklesScroll || '0');
      const next = current + scrollDelta * SPEED;
      host.dataset.sparklesScroll = String(next);
      host.style.setProperty('--sparkles-scroll', next + 'px');
    });
    scrollDelta = 0;
  };

  const onScroll = () => {
    const y = window.scrollY;
    scrollDelta += (y - lastScrollY);
    lastScrollY = y;
    if (!pending) {
      pending = true;
      requestAnimationFrame(update);
    }
  };

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!prefersReducedMotion.matches) {
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
